import { BarChart3, Download } from 'lucide-react'

function Relatorios() {
  return (
    <>
      {/* Page Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Relatórios</h1>
          <p className="mt-1 text-sm text-gray-600">Análises e relatórios do sistema</p>
        </div>
        <div className="mt-4 sm:mt-0 flex space-x-3">
          <button className="px-4 py-2 text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 transition-all duration-200 shadow-theme-sm font-medium">
            <Download className="w-4 h-4 mr-2 inline" />
            Exportar
          </button>
        </div>
      </div>

      {/* Reports */}
      <div className="bg-white rounded-xl border border-gray-200 shadow-theme-sm">
        <div className="p-6">
          <div className="text-center py-8">
            <BarChart3 className="w-16 h-16 text-gray-300 mx-auto mb-4" />
            <h3 className="text-lg font-semibold text-gray-900 mb-2">Nenhum relatório disponível</h3>
            <p className="text-gray-600">Os relatórios aparecerão aqui conforme forem gerados.</p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Relatorios
